module.exports = __webpack_public_path__ + "static/img/order-mobile-5.7ad26a77.png";